// extracted by mini-css-extract-plugin
export default {"root":"style_root__YyU7+","header":"style_header__PSl6j","content":"style_content__+8SgI"};